module.exports = __webpack_public_path__ + "static/img/right.7eab780.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/right.png
// module id = VgxF
// module chunks = 1